import { z } from 'zod';

export const AddSupplierCapabilityBodySchema = z.object({
  serviceKindSlug: z.string().trim().min(1).max(80),
});

export type AddSupplierCapabilityBody = z.infer<typeof AddSupplierCapabilityBodySchema>;

export const AddSupplierCapabilityResponseSchema = z.object({
  capabilityId: z.uuid(),
});

export type AddSupplierCapabilityResponse = z.infer<typeof AddSupplierCapabilityResponseSchema>;

export const SupplierCapabilityItemSchema = z.object({
  id: z.uuid(),
  serviceKindSlug: z.string(),
  createdAt: z.iso.datetime(),
});

export type SupplierCapabilityItem = z.infer<typeof SupplierCapabilityItemSchema>;

export const ListSupplierCapabilitiesResponseSchema = z.object({
  items: z.array(SupplierCapabilityItemSchema),
});

export type ListSupplierCapabilitiesResponse = z.infer<
  typeof ListSupplierCapabilitiesResponseSchema
>;

export const ServiceKindItemSchema = z.object({
  slug: z.string(),
  name: z.string(),
});

export type ServiceKindItem = z.infer<typeof ServiceKindItemSchema>;

export const ListServiceKindsResponseSchema = z.object({
  items: z.array(ServiceKindItemSchema),
});

export type ListServiceKindsResponse = z.infer<typeof ListServiceKindsResponseSchema>;
